import moment from "moment";
import dateFormats from "../../../../app/data/common/dateFormats";

export const TIME_UI_PARSE_FORMATS = [
  "HH:mm:ss",
  "HH:mm",
  "h:mm a",
  "h:mm A",
  "h:mma",
  "h:mmA",
];

/** Normalize BOL / API time strings to Create Pickup dropdown format (`h:mm a`). */
export const normalizeTimeForUiDisplay = (time?: string | null): string => {
  if (!time?.trim()) return "";

  const trimmed = time.trim();
  const strict = moment(trimmed, TIME_UI_PARSE_FORMATS, true);
  if (strict.isValid()) return strict.format("h:mm a");

  const loose = moment(trimmed, TIME_UI_PARSE_FORMATS);
  if (loose.isValid()) return loose.format("h:mm a");

  return trimmed;
};

/** @deprecated Prefer normalizeTimeForUiDisplay */
export const convertToAmPm = (time?: string | null): string => normalizeTimeForUiDisplay(time);

export const bolDateToUiFormat = (date?: string | null): string => {
  if (!date?.trim()) return "";
  const trimmed = date.trim();
  const parsed = moment(
    trimmed,
    [dateFormats.apiDate, dateFormats.uiDate, moment.ISO_8601],
    true
  );
  return parsed.isValid() ? parsed.format(dateFormats.uiDate) : trimmed;
};

export const bolDateToApiFormat = (date?: string | null): string => {
  if (!date?.trim()) return "";
  const trimmed = date.trim();
  const parsed = moment(
    trimmed,
    [dateFormats.uiDate, dateFormats.apiDate, "MM/DD/YYYY", "M/D/YYYY", moment.ISO_8601],
    true
  );
  if (parsed.isValid()) return parsed.format(dateFormats.apiDate);
  try {
    return trimmed.toApiDateFormat();
  } catch {
    const loose = moment(trimmed);
    return loose.isValid() ? loose.format(dateFormats.apiDate) : "";
  }
};

export const safeBolDate = (date?: string | null): string => bolDateToUiFormat(date);

export const safeBolTime = (time?: string | null): string => normalizeTimeForUiDisplay(time);
